module.exports = __webpack_public_path__ + "img/4-fr.b1a1317c.jpg";